const approval = `#pragma version 6
txn ApplicationID
int 0
==
bnz main_l34
txn OnCompletion
int DeleteApplication
==
bnz main_l33
txn OnCompletion
int UpdateApplication
==
bnz main_l32
txn OnCompletion
int CloseOut
==
bnz main_l31
txn OnCompletion
int OptIn
==
bnz main_l30
txna ApplicationArgs 0
byte "discount_buy"
==
bnz main_l27
txna ApplicationArgs 0
byte "get_token"
==
bnz main_l12
txna ApplicationArgs 0
byte "appAddressOptin"
==
bnz main_l11
txna ApplicationArgs 0
byte "claimWithReceiver"
==
bnz main_l10
err
main_l10:
global GroupSize
int 2
==
assert
gtxn 0 TypeEnum
int pay
==
assert
gtxn 0 Sender
gtxn 1 Sender
==
assert
gtxn 0 Receiver
global CurrentApplicationAddress
==
assert
gtxn 0 Amount
int 1000
==
assert
itxn_begin
int axfer
itxn_field TypeEnum
byte "usdcID"
app_global_get
itxn_field XferAsset
byte "Total"
app_global_get
itxn_field AssetAmount
byte "receiver"
app_global_get
itxn_field AssetReceiver
itxn_submit
int 1
return
main_l11:
global GroupSize
int 3
==
assert
gtxn 0 Sender
byte "Creator"
app_global_get
==
assert
gtxn 0 Receiver
global CurrentApplicationAddress
==
assert
gtxn 0 Amount
int 302000
==
assert
byte "elemID"
app_global_get
callsub assetHandleOptin_1
byte "usdcID"
app_global_get
callsub assetHandleOptin_1
gtxn 2 TypeEnum
int axfer
==
assert
gtxn 2 XferAsset
byte "elemID"
app_global_get
==
assert
gtxn 2 Sender
txn Sender
==
assert
gtxn 2 AssetReceiver
global CurrentApplicationAddress
==
assert
gtxn 2 AssetAmount
int 1000000000000
==
assert
int 1
return
main_l12:
global GroupSize
int 2
==
assert
gtxn 0 TypeEnum
int pay
==
assert
gtxn 0 Sender
gtxn 1 Sender
==
assert
gtxn 0 Receiver
global CurrentApplicationAddress
==
assert
gtxn 0 Amount
int 1000
==
assert
global LatestTimestamp
int 0
byte "MyTime"
app_local_get
-
store 7
load 7
int 300
>=
assert
int 0
byte "MyAmountBond"
app_local_get
store 20
int 0
byte "MyAmountStable"
app_local_get
store 8
load 20
int 0
>
assert
load 8
int 0
>
assert
byte "Total"
app_global_get
int 0
>
assert
int 20
load 8
*
int 100
/
store 14
callsub timeMul_2
load 14
*
store 10
load 20
load 10
>=
bnz main_l20
byte "elemID"
app_global_get
load 20
callsub assetHandleTxn_0
int 0
global CurrentApplicationID
byte "count"
app_local_get_ex
store 5
store 2
load 5
bnz main_l17
callsub timeMul_2
store 46
int 0
byte "count"
load 46
app_local_put
callsub timeMul_2
int 5
==
load 46
int 5
==
||
bnz main_l16
int 0
global CurrentApplicationID
byte "MyAmountBond"
app_local_get_ex
store 9
store 6
load 9
assert
load 6
load 20
-
store 12
int 0
byte "MyAmountBond"
load 12
app_local_put
int 0
byte "MyTime"
app_local_get
int 300
callsub timeMul_2
*
+
store 44
int 0
byte "MyTime"
load 44
app_local_put
int 1
return
main_l16:
int 0
byte "MyAmountStable"
int 0
app_local_put
int 0
byte "MyAmountBond"
int 0
app_local_put
int 0
byte "MyTime"
int 0
app_local_put
int 1
return
main_l17:
load 2
callsub timeMul_2
+
store 45
int 0
byte "count"
load 45
app_local_put
gtxn 1 CloseRemainderTo
global ZeroAddress
==
assert
callsub timeMul_2
int 5
==
load 45
int 5
==
||
bnz main_l19
int 0
global CurrentApplicationID
byte "MyAmountBond"
app_local_get_ex
store 9
store 6
load 9
assert
load 6
gtxn 1 AssetAmount
-
store 12
int 0
byte "MyAmountBond"
load 12
app_local_put
int 0
byte "MyTime"
app_local_get
int 300
callsub timeMul_2
*
+
store 44
int 0
byte "MyTime"
load 44
app_local_put
int 1
return
main_l19:
int 0
byte "MyAmountStable"
int 0
app_local_put
int 0
byte "MyAmountBond"
int 0
app_local_put
int 0
byte "MyTime"
int 0
app_local_put
int 1
return
main_l20:
byte "elemID"
app_global_get
load 10
callsub assetHandleTxn_0
int 0
global CurrentApplicationID
byte "count"
app_local_get_ex
store 5
store 2
load 5
bnz main_l24
callsub timeMul_2
store 46
int 0
byte "count"
load 46
app_local_put
callsub timeMul_2
int 5
==
load 46
int 5
==
||
bnz main_l23
int 0
global CurrentApplicationID
byte "MyAmountBond"
app_local_get_ex
store 9
store 6
load 9
assert
load 6
load 10
-
store 12
int 0
byte "MyAmountBond"
load 12
app_local_put
int 0
byte "MyTime"
app_local_get
int 300
callsub timeMul_2
*
+
store 44
int 0
byte "MyTime"
load 44
app_local_put
int 1
return
main_l23:
int 0
byte "MyAmountStable"
int 0
app_local_put
int 0
byte "MyAmountBond"
int 0
app_local_put
int 0
byte "MyTime"
int 0
app_local_put
int 1
return
main_l24:
load 2
callsub timeMul_2
+
store 45
int 0
byte "count"
load 45
app_local_put
gtxn 1 CloseRemainderTo
global ZeroAddress
==
assert
callsub timeMul_2
int 5
==
load 45
int 5
==
||
bnz main_l26
int 0
global CurrentApplicationID
byte "MyAmountBond"
app_local_get_ex
store 9
store 6
load 9
assert
load 6
gtxn 1 AssetAmount
-
store 12
int 0
byte "MyAmountBond"
load 12
app_local_put
int 0
byte "MyTime"
app_local_get
int 300
callsub timeMul_2
*
+
store 44
int 0
byte "MyTime"
load 44
app_local_put
int 1
return
main_l26:
int 0
byte "MyAmountStable"
int 0
app_local_put
int 0
byte "MyAmountBond"
int 0
app_local_put
int 0
byte "MyTime"
int 0
app_local_put
int 1
return
main_l27:
global GroupSize
int 2
==
assert
gtxn 1 XferAsset
byte "usdcID"
app_global_get
==
assert
gtxn 1 TypeEnum
int axfer
==
assert
gtxn 1 Sender
txn Sender
==
assert
gtxn 1 AssetReceiver
global CurrentApplicationAddress
==
assert
byte "Total"
byte "Total"
app_global_get
gtxn 1 AssetAmount
+
app_global_put
int 0
global CurrentApplicationID
byte "MyAmountStable"
app_local_get_ex
store 1
store 0
load 1
bnz main_l29
int 0
byte "MyAmountBond"
gtxn 1 AssetAmount
int 2
/
app_local_put
int 0
byte "MyAmountStable"
gtxn 1 AssetAmount
int 2
/
app_local_put
int 0
byte "MyTime"
global LatestTimestamp
app_local_put
int 1
return
main_l29:
int 0
byte "MyAmountBond"
app_local_get
gtxn 1 AssetAmount
int 2
/
+
store 4
load 0
gtxn 1 AssetAmount
int 2
/
+
store 3
int 0
byte "MyAmountBond"
load 4
app_local_put
int 0
byte "MyAmountStable"
load 3
app_local_put
int 0
byte "MyTime"
global LatestTimestamp
app_local_put
int 0
byte "count"
app_local_del
int 1
return
main_l30:
int 1
return
main_l31:
int 1
return
main_l32:
txn Sender
byte "Creator"
app_global_get
==
assert
int 1
return
main_l33:
txn Sender
byte "Creator"
app_global_get
==
return
main_l34:
byte "Creator"
txn Sender
app_global_put
txn NumAppArgs
int 3
==
assert
byte "Receiver"
txna ApplicationArgs 0
app_global_put
byte "elemID"
txna ApplicationArgs 1
btoi
app_global_put
byte "usdcID"
txna ApplicationArgs 2
btoi
app_global_put
byte "Total"
int 0
app_global_put
int 1
return

// assetHandleTxn
assetHandleTxn_0:
store 13
store 11
itxn_begin
int axfer
itxn_field TypeEnum
load 11
itxn_field XferAsset
load 13
itxn_field AssetAmount
txn Sender
itxn_field AssetReceiver
itxn_submit
retsub

// assetHandleOptin
assetHandleOptin_1:
store 17
itxn_begin
int axfer
itxn_field TypeEnum
load 17
itxn_field XferAsset
int 0
itxn_field AssetAmount
global CurrentApplicationAddress
itxn_field AssetReceiver
itxn_submit
retsub

// timeMul
timeMul_2:
int 0
byte "MyTime"
app_local_get
store 15
global LatestTimestamp
load 15
-
int 300
/
store 16
load 16
int 5
<
bnz timeMul_2_l2
int 5
retsub
timeMul_2_l2:
load 16
retsub`;

export default approval